<template lang="pug">
form.login-form(name='form', novalidate)

	.login-body

		h3 New Customer
		// p: b New Customer
		br

		p Creating a new account is free, fast and simple. All you need to provide is a user name, a valid email, and a password. This is required in order to save any information that you enter for your project. By registering, you implicitly agree to our #[a(href='http://www-staging.easytitle24.com/terms-and-conditions' target='_blank') Terms and Conditions.]
		br

		p(v-if='errors.length')
			b Please correct the following error(s):
			ul
				li(v-for='error in errors') {{ error }}

		.login-lbl
			label First Name
			b-form-input.login-field(type='text', name='fname', v-model='user.contact.firstName', required, autofocus, novalidate='')

		.login-lbl
			label Last Name
			b-form-input.login-field(type='text', name='lname', v-model='user.contact.lastName', required, autofocus, novalidate='')

		.login-lbl
			// label {{ $t('label.username') }}
			label Username:
			b-form-input.login-field(type='text', name='login', v-model='user.account.username', required, autofocus, novalidate='')

		.login-lbl
			label Email Address:
			b-form-input.login-field(type='email', name='email', v-model='user.contact.email', required, autofocus, novalidate='')

		.login-lbl
			// label {{ $t('label.password') }}
			Label Password:
			b-form-input.login-field(name="pass", type='password', v-model='user.account.password', required, novalidate='')

		.login-lbl
			// label {{ $t('label.retypePass') }}
			Label Confirm Password:
			b-form-input.login-field(name="pass", type='password', v-model='user.account.retypePassword', required, novalidate='')

		.btn-login-cnt
			b-button(variant="success", size="lg", @click='register') Register
</template>

<script>
import Vue from 'vue'
import store from 'CommonApp/store'

export default {
	name: 'new-customer-form',
	props: ['snackbar'],
	data () {
		return {
			errors: [],
			user: {
				account: {
					username: null,
					password: null,
					retypePassword: null
				},
				contact: {
					firstName: null,
					lastName: null,
					email: null
				}
			}
		}
	},
	methods: {
		loginAttempt (username, password) {
			let authError = null

			// Try to login
			Vue.e24.security.login(username, password).then((loggedIn) => {
				if (!loggedIn) {
					// If we get here then the login failed due to bad credentials
					authError = 'login.error.invalidCredentials'
				} else {
					// let redirect = (this.entryUrl || {name: 'project.list'})
					let redirect = (this.entryUrl || {name: 'project.new'})
					// Clean requested url
					store.dispatch({
						type: 'updateEntryUrl',
						value: null
					})
					// Login success
					this.$router.push(redirect)
				}
			}, (err) => {
				// If we get here then there was a problem with the login request to the server
				console.error('Server is unavailable or returned an error', err)
				authError = 'login.error.serverError'
			})

			// Goto login and show error
			if (authError) {
				this.$router.push({name: 'login', params: { goodbye: '', redirect: '', error: authError }})
			}
		},
		// Create new account
		register () {
			// Validate required fields
			this.errors = []

			if (!this.user.account.username) {
				this.errors.push('Username required.')
			}

			if (!this.user.account.retypePassword) {
				this.errors.push('Password must match.')
			} else {
				try {
					Vue.jnx.validationService.password(this.user.account.password, this.user.account.retypePassword)
				} catch (err) {
					console.log('err', err.message)
					switch (err.message) {
					case 'notMatch':
						this.errors.push('Password must match.')
						break
					case 'strength':
						this.errors.push('Password required. Must be alphanumeric, between 8 and 20')
						break
					}
				}
			}

			if (!Vue.jnx.validationService.email(this.user.contact.email)) {
				this.errors.push('Email required.')
			}
			if (!this.user.contact.firstName) {
				this.errors.push('First Name required.')
			}
			if (!this.user.contact.lastName) {
				this.errors.push('Last Name required.')
			}

			if (this.errors.length === 0) {
				Vue.jnx.userActionService.insert(this.user).then((result) => {
					console.log('Inserted user', result)
					// Login
					this.loginAttempt(this.user.account.username, this.user.account.password)
				}, (error) => {
					this.snackbar.message = error.message
					this.snackbar.show = true
					console.log('Error creating account', error)
				})
			}
		}
	},
	computed: {
		entryUrl () {
			return this.$store.getters.entryUrl
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/app/login/new-customer.vue